/* eslint-disable jira/filename-case */
import type { ChangeFavoritePayload as Request } from '../model/types.tsx';
import { updateFavorite } from '../rest/update-favorite.tsx';

const updateFavorite1 = async (request: Request): Promise<void> => updateFavorite(request);

export default updateFavorite1;
